import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Gift, Heart, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";

export function TryMyCareHomeBanner() {
  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.5 }}
    >
      <Card className="border-success/30 bg-gradient-to-br from-success/5 to-primary/5 overflow-hidden">
        <CardContent className="p-5">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-2xl bg-success/10 flex items-center justify-center flex-shrink-0">
              <Gift className="w-6 h-6 text-success" />
            </div>
            <div className="flex-1">
              <h3 className="font-display font-bold text-foreground text-base mb-1">
                Try My Care
              </h3>
              <p className="text-sm text-muted-foreground mb-3">
                Experience a doctor's treatment before paying. Choose a Try My Care doctor and receive{" "}
                <span className="font-bold text-success">3 free consultations</span>.
              </p>
              <Button
                size="sm"
                className="bg-success text-success-foreground hover:bg-success/90"
                onClick={() => navigate("/doctors?filter=try_my_care")}
              >
                <Heart className="w-4 h-4 mr-2" />
                Find Try My Care Doctors
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
}
